import _regenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/usr/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import fetcher from "../../common/axiosInstance";
import NotFound404Exception from "@/exceptions/NotFound404Exception";
export var api__getPostInspection = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(postId) {
    var _res$data, _res$data$data, _res$data2, _res$data2$data, _res$data2$data$inspe, _res$data3, _res$data3$data;
    var params, res;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          params = {
            id: postId,
            thumb_size: 300,
            device_type: "web",
            include: "inspection"
          };
          _context.n = 1;
          return fetcher().get("/post/view-online", {
            params: params
          });
        case 1:
          res = _context.v;
          if (!(!(res !== null && res !== void 0 && (_res$data = res.data) !== null && _res$data !== void 0 && (_res$data$data = _res$data.data) !== null && _res$data$data !== void 0 && _res$data$data.inspection) || (res === null || res === void 0 ? void 0 : (_res$data2 = res.data) === null || _res$data2 === void 0 ? void 0 : (_res$data2$data = _res$data2.data) === null || _res$data2$data === void 0 ? void 0 : (_res$data2$data$inspe = _res$data2$data.inspection) === null || _res$data2$data$inspe === void 0 ? void 0 : _res$data2$data$inspe.length) === 0)) {
            _context.n = 2;
            break;
          }
          throw new NotFound404Exception("Report for post ".concat(postId, " Not Found"));
        case 2:
          return _context.a(2, (res === null || res === void 0 ? void 0 : (_res$data3 = res.data) === null || _res$data3 === void 0 ? void 0 : (_res$data3$data = _res$data3.data) === null || _res$data3$data === void 0 ? void 0 : _res$data3$data.inspection) || null);
      }
    }, _callee);
  }));
  return function api__getPostInspection(_x) {
    return _ref.apply(this, arguments);
  };
}();